// extracted by css-extract-rspack-plugin
var _1 = "ttkCpQK0pK4ZvjXP";
var _2 = "du2kum1acge8xVch";
var _3 = "qAggQNXWOcoHr7bV";
var _4 = "zMtIQa_cyyEzi3Ug";
var _5 = "PoFxHL6HTYjO1fZY";
var _6 = "PoFxHL6HTYjO1fZY";
var _7 = "ysHvW4WZyYsNR0zn";
var _8 = "SKYpPfvPwVsHhMUN";
var _9 = "SKYpPfvPwVsHhMUN";
var _a = "Chk9VQMHnMUGWR4b";
var _b = "R8S4vodbnPwrHjMR";
var _c = "R8S4vodbnPwrHjMR";
export { _1 as "away", _2 as "extended", _3 as "home", _4 as "placeholder", _5 as "resultText", _6 as "result__text", _7 as "subtitle", _8 as "team-wrap", _9 as "teamWrap", _a as "title", _b as "vs-team", _c as "vsTeam" }
